import $ from 'jquery';
import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Select from '@material-ui/core/Select';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import { getUrlParameter } from '../../utils';

const refCode = getUrlParameter('ref');

const useStyles = makeStyles(theme => ({
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  progressBar: {
    margin: 'auto',
    position: 'absolute',
    top: '50%'
  },
  formControl: {
    padding: "8px",
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0
  }
}));

export default function Signup(props) {
  const { user } = props;
  const classes = useStyles();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [verified, setVerified] = useState(false);
  const [verificationType, setVerificationType] = useState(null);
  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);
  React.useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  function handleSubmit(event) {
    event.preventDefault();
    const formData = new FormData(event.target)
    setLoading(true);
    setVerificationType(document.getElementById('uploaded_file').value? 'id': 'msg');

    $.ajax({
      url: '/user_account/verification/',
      data: formData,
      method: 'POST',
      processData: false,
      contentType: false,
      success(response) {
        setLoading(false);
        if (!response.error){
            setVerified(true);
        }else{
            setErrors(response);
        }
      },
      error(xhr) {
        let error = {}
        if (xhr.readyState === 4) {
          error = JSON.parse(xhr.responseText)
        }
        else if (xhr.readyState === 0) {
          error = {common_error: "Connection error."}
        }
        else {
          error = {common_error: "Something went wrong."}
        }
        setErrors(error)
        setLoading(false)
      }
    });
  }

  if (loading)
    return (
      <div style={{ textAlign: 'center' }}>
        <CircularProgress className={classes.progressBar} />
      </div>
    );

   if (verified){
    return (
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Verify Account
        </Typography>
        <Typography variant="subtitle1" display="block" gutterBottom align="justify" style={{color: 'gray', margin: 20}}>
          {
              verificationType === 'id'?
              "We'll review your account and send you a confirmation email during 24 hours.":
              "Ok, we'll wait for your message on Twitter or Facebook."
          }
        </Typography>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick={()=>{window.history.back()}}
        >
          Back
        </Button>
      </div>
    )
   }

  return (
    <div className={classes.paper}>
      <Avatar className={classes.avatar}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        Verify Account
      </Typography>
      <form className={classes.form} noValidate onSubmit={handleSubmit} method="POST" enctype="multipart/form-data">
        <input
          type="hidden"
          id="referralCode"
          name="referralCode"
          value={refCode}
        />
        <Grid container spacing={2}>
          <Grid item xs={12} style={{marginTop: "5px"}}>
            <Typography variant="caption" display="block" gutterBottom align="justify" style={{color: 'gray'}}>
              &nbsp;&nbsp;&nbsp;&nbsp; We highly value the security and confidentiality of chess players, so we will not
              disclose your personal information for any purpose unless you consent to it.
            </Typography>
          </Grid>
          {user && errors.username &&
            <Typography color="error" variant="caption" display="block" gutterBottom>
              * {errors.username}
            </Typography>}
          {!user && <Grid item xs={12}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="username"
              name="username"
              label="Username"
              type="text"
              error={Boolean(errors.username)}
              helperText={errors.username}
            />
          </Grid>}
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              fullWidth
              required
              id="name_or_link"
              name="name_or_link"
              label="Full name or FIDE profile link"
              type="text"
              error={Boolean(errors.name_or_link)}
              helperText={errors.name_or_link}
            />
          </Grid>
          <Grid items xs={12} className={classes.formControl}>
            <FormControl variant="outlined"
                         fullWidth
                         required
                         error={Boolean(errors.chess_title)}
                         helperText={errors.chess_title}
              >
              <InputLabel ref={inputLabel} id="chess_title">
                Chess Title
              </InputLabel>
              <Select
                labelId="select-chess-title"
                id="select-chess-title"
                name="chess_title"
                labelWidth={labelWidth}
              >
                <MenuItem value="grandmaster">Grandmaster (2500 coins)</MenuItem>
                <MenuItem value="international-master">International Master (1000 coins)</MenuItem>
                <MenuItem value='other'>Other (500 coins)</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="promo_code"
              name="promo_code"
              label="Promo Code"
              type="text"
              error={Boolean(errors.promo_code)}
              helperText={errors.promo_code}
            />
          </Grid>
          <Grid items xs={12} style={{marginTop: "20px"}}>
            <FormControl component="fieldset" className={classes.formControl}>
              <FormLabel component="legend">Please choose one of the options below to prove your identity.</FormLabel>
                <List component="nav">
                  <ListItem className={classes.list}>
                    <ListItemText primary="Upload your personal ID image."/>
                    <Button
                      variant="contained"
                      component="label"
                      size='small'
                    >
                      Upload Image
                      <input
                        type="file"
                        style={{ display: "none" }}
                        accept="image/*"
                        name="uploaded_file"
                        id="uploaded_file"
                      />
                    </Button>
                  </ListItem>
                  <ListItem className={classes.list}>
                    <ListItemText secondary="or" />
                  </ListItem>
                  <ListItem className={classes.list}>
                    <ListItemText primary={<span>Write us a personal message on <a target="_blank" href="https://www.facebook.com/chessify.me/">
                    Facebook</a> or <a target="_blank" href="https://twitter.com/chessifyme">Twitter</a> from your account.</span>}/>
                  </ListItem>
                 </List>
            </FormControl>
          </Grid>
        </Grid>
        <Typography color="error">
          {errors.non_field_errors
            ? errors.non_field_errors
            : errors.common_error}
        </Typography>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
        >
          Verify
        </Button>
        <Grid container justify="flex-end">
          <Grid item>
            <Typography
              color="primary"
              variant="body2"
              style={{ cursor: 'pointer' }}
              onClick={()=>{window.history.back()}}
            >
              Back
            </Typography>
          </Grid>
        </Grid>
      </form>
    </div>
  );
}